import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Seo from "../../Components/SeoComponent/Seo";
import {
  DivTag,
  Button,
  InputField,
  ImgTag,
  FormTag,
} from "../../Components/Tags/Tags";
import SliderCrousel from "../../Components/SliderLoginPage/SliderCrousel";
import { FaRegUser } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import ReCAPTCHA from "react-google-recaptcha";
// import { Turnstile } from '@marsidev/react-turnstile';

import {
  ForgotPasswordGetOtp,
  ForgotPasswordReset,
  ForgotPasswordVerifyOtp,
  ForgotPinReset,
  getLocation,
  login,
  loginWithOtp,
  NewsService,
  verifyPin,
} from "../../Services/authService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalWithPinInput from "../../Components/ModalWithPinComponent/ModalWithPinInput";
import { Link } from "react-router-dom";

import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import SliderCrousel2 from "../../Components/SliderCrousel2";
import Loader from "../../Loader";
import NetworkBackground from "./NetworkBackground";
import LoginwithOtpModal from "./LoginwithOtpModal";
import {
  AlertTriangle,
  ArrowBigRight,
  ArrowBigUpDash,
  ArrowUpIcon,
  ArrowUpZaIcon,
  IndianRupee,
  Key,
  KeyIcon,
  KeyRound,
  Lock,
  LogIn,
  Newspaper,
  Phone,
  PlusSquare,
  Receipt,
  ScrollText,
  ShieldCheck,
  SmartphoneCharging,
  SmartphoneChargingIcon,
  SmartphoneNfc,
  User2,
  Zap,
} from "lucide-react";
import { ArrowBackIos } from "@mui/icons-material";
import { isNumeric } from "validator";
import ForgotPasswordOtpModal from "./ForgotPasswordOtpModal";
import PasswordPinModal from "./PasswordPinModal";

const LoginUserPage = () => {
  const [user_id, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pin, setPin] = useState("");
  const [tempToken, setTempToken] = useState("");
  const [captchaToken, setCaptchaToken] = useState(false);
  const [newsData, setNewsData] = useState("");
  const [loginMethod, setLoginMethod] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [userIdFocus, setUserIdFocus] = useState(false);
  const [passwordFieldFocus, setPasswordFieldFocus] = useState(false);
  const [passwordClicked, setPasswordClicked] = useState(false);
  const [otpAccessClicked, setOtpAccessClicked] = useState(false);
  const [forgotPasswordClicked, setForgotPasswordClicked] = useState(false);
  const [phone, setPhone] = useState(null);
const [userLatitude, setUserLatitude] = useState(null)
const [userLongitude, setUserLongitude] = useState(null)
const [otpMessage, setOtpMessage] = useState(null)

  const [userIdInputError, setUserIdnputError] = useState(null);
  const [showOtpModalForgotPassword, setShowOtpModalForgotPassword] =
    useState(false);
  const [forgotPasswordResponse, setForgotPasswordResponse] = useState(null);
  const [
    forgotPasswordVerificationResponse,
    setForgotPasswordVerificationResponse,
  ] = useState(null);
  const [showPasswordPinModal, setShowPasswordPinModal] = useState(false);

  const [isVerifying, setIsVerifying] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = !!Cookies.get("authTokenUser");
    if (isLoggedIn) {
      setIsLoading(true);
      navigate("/Dashboard");
      setIsLoading(false);
    }
  }, [navigate]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleCaptchaChange = () => {
    setCaptchaToken(!captchaToken);
  };

  const handleForgotPassword = async () => {
    if (forgotPasswordClicked) {
      setUserIdnputError(null);
      setIsLoading(true);
      try {
        const response = await ForgotPasswordGetOtp({ user_id });

        if (response) {
          //  console.log(response);
        }

        if (response?.reference_id) {
          setShowOtpModalForgotPassword(true);
          setForgotPasswordResponse(response);
        } else {
          showErrorToast(response?.message || response?.data?.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const verifyOtpForgotPassword = async (otp) => {
    if (forgotPasswordClicked) {
      setIsLoading(true);
      setUserIdnputError(null);
      try {
        const response = await ForgotPasswordVerifyOtp({
          reference_id: forgotPasswordResponse?.reference_id,
          temp_token: forgotPasswordResponse?.temp_token,
          otp,
        });

        if (response) {
          // console.log("verify otp response", response);
        }

        if (response?.temp_token) {
          setShowOtpModalForgotPassword(false);
          setForgotPasswordClicked(false);
          setShowPasswordPinModal(true);
          setForgotPasswordVerificationResponse(response);
          showSuccessToast(response?.message || response?.data?.message);
        } else {
          showErrorToast(response?.message || response?.data?.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleResetPassword = async (newPassword, confirmNewPassword) => {
    if (newPassword?.length === 0) {
      return showErrorToast("Please enter password");
    } else if (newPassword?.length < 8) {
      return showErrorToast("Enter at least 8 characters");
    }
    if (confirmNewPassword?.length === 0) {
      return showErrorToast("Please enter confirm password");
    } else if (confirmNewPassword?.length < 8) {
      return showErrorToast("Enter at least 8 characters");
    } else if (newPassword !== confirmNewPassword) {
      return showErrorToast("password and confirm password should be same");
    }

    setUserIdnputError(null);
    setIsLoading(true);
    try {
      const response = await ForgotPasswordReset({
        temp_token: forgotPasswordVerificationResponse?.temp_token,
        password: newPassword,
        password_confirmation: confirmNewPassword,
      });

      if (response) {
        console.log("reset password response", response);
      }

      if (
        response?.status?.code === 200 ||
        response?.data?.status?.code === 200
      ) {
        setShowOtpModalForgotPassword(false);
        setForgotPasswordVerificationResponse(response);
        showSuccessToast(response?.message || response?.status?.message);
      } else {
        showErrorToast(
          response?.status?.message ||
            response?.message ||
            response?.data?.status?.message,
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setShowPasswordPinModal(false);
    }
  };
  const handleResetPin = async (newPin, confirmNewPin) => {
    if (newPin?.length === 0) {
      return showErrorToast("Please enter pin");
    } else if (newPin?.length < 6) {
      return showErrorToast("Enter at least 8 characters");
    }
    if (confirmNewPin?.length === 0) {
      return showErrorToast("Please enter confirm pin");
    } else if (confirmNewPin?.length < 6) {
      return showErrorToast("Enter at least 6 numbers");
    } else if (newPin !== confirmNewPin) {
      return showErrorToast("pin and confirm pin should be same");
    }
    setUserIdnputError(null);
    setIsLoading(true);

    try {
      const response = await ForgotPinReset({
        temp_token: forgotPasswordVerificationResponse?.temp_token,
        pin: newPin,
        pin_confirmation: confirmNewPin,
      });

      if (response?.message) {
        //  console.log("reset pin response", response);
      }

      if (
        response?.status?.code === 200 ||
        response?.data?.status?.code === 200
      ) {
        setShowOtpModalForgotPassword(false);
        setForgotPasswordVerificationResponse(response);
        showSuccessToast(response?.message || response?.status?.message);
      } else {
        showErrorToast(
          response?.status?.message ||
            response?.message ||
            response?.data?.status?.message,
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setShowPasswordPinModal(false);
    }
  };

  const handleReset = (
    mode,
    newPin,
    confirmNewPin,
    newPassword,
    confirmNewPassword,
  ) => {
    // console.log("reset clicked");
    // console.log(mode, newPin, confirmNewPin, newPassword, confirmNewPassword);

    if (mode === "password") {
      handleResetPassword(newPassword, confirmNewPassword);
    } else {
      handleResetPin(newPin, confirmNewPin);
    }
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   if (user_id.trim() === '' || password.trim() === '') {
  //     showErrorToast('Please enter Username and Password');
  //     return;
  //   }

  //   if (!captchaToken) {
  //     showErrorToast("Please complete the reCAPTCHA.");
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const result = await login({ user_id, password, captchaToken });

  //     if (result.message === "Please enable location services.") {
  //       showErrorToast("Location permission denied. Please allow access to location.");
  //       return;
  //     }

  //     if (result.success === false && result.data.temp_token) {
  //       setTempToken(result.data.temp_token);
  //       showSuccessToast(result.message || "Step 1 successful. Please verify your PIN.");
  //       setIsModalOpen(true);
  //     } else {
  //       showErrorToast(result.data.message || "Login failed.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     if (error.message === "Location access denied or unavailable.") {
  //       showErrorToast("Location permission denied. Please allow access to your location.");
  //     } else {
  //       showErrorToast("Server error occurred.");
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (user_id.trim() === "") {
      return setUserIdnputError("Please enter User ID");
    } else if (user_id.length < 8) {
      return setUserIdnputError("Please enter 8 Digit ");
    }

    if (!captchaToken) {
      showErrorToast("Please complete the reCAPTCHA.");
      return;
    }

    setIsLoading(true);

    try {
      // =======================
      // CASE 1: LOGIN WITH OTP
      // =======================
      if (loginMethod === "otp") {
        const result = await loginWithOtp({ user_id });

        if (result.success || result.data?.identifier) {
          setTempToken(result.data.temp_token || result.data.data.temp_token);
          setReferenceId(result.data.identifier || result.data.data.identifier);
          setOtpMessage(result?.data?.data?.message)
          setShowOtpModal(true); // ✅ Show OTP Modal
          showSuccessToast(
            result.message || "OTP sent successfully. Please verify your OTP.",
          );
          return;
        }

        showErrorToast(
          result.message || result.error.message || "Failed to send OTP",
        );
        return;
      }

      // =======================
      // CASE 2: LOGIN WITH PASSWORD
      // =======================
      if (password.trim() === "") {
        showErrorToast("Please enter Password");
        return;
      }

      const result = await login({ user_id, password, latitude: userLatitude, longitude: userLongitude });

      // Step 2 (PIN modal case)
      if (!result.success && result.data?.temp_token) {
        setTempToken(result.data.temp_token);
        setIsModalOpen(true); // ✅ Show PIN Modal
        showSuccessToast("Step 1 successful. Please verify your PIN.");
        return;
      }

      // Direct success (rare case)
      if (result.success && result.data?.accessToken) {
        navigate("/Dashboard");
        showSuccessToast("Logged in successfully!");
        return;
      }

      // ✅ Handle all error cases correctly
      showErrorToast(
        result?.message ||
          result?.error?.message ||
          result?.error ||
          "Invalid user_id or password",
      );
    } catch (error) {
      showErrorToast(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong! Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handlePinSubmit = async () => {
    if (pin.length < 6) {
      showErrorToast("Please enter a valid PIN.");
      return;
    }
    setIsLoading(true); // Show loading state
    try {
      const result = await verifyPin(pin.join(""), tempToken, userLatitude, userLongitude); // Join PIN digits
      if (result.success) {
        isLoading(true);
        navigate("/Dashboard"); // Redirect to dashboard
        isLoading(false);
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      showErrorToast("Error verifying PIN.");
    } finally {
      setIsLoading(false); // Hide loading state
    }
  };

  // Retrieve News Data
  const newsRetrieve = async () => {
    try {
      setIsLoading(true);
      const response = await NewsService();
      setNewsData(response?.data);
      // console.log(response);
    } catch (error) {
      console.error("Error fetching News data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user_id.length === 8) {
      setUserIdnputError("");
    }
  }, [user_id]);

  useEffect(() => {
    newsRetrieve();
  }, []);

  useEffect(() => {
    if (!forgotPasswordClicked) return;

    handleForgotPassword();
  }, [forgotPasswordClicked]);

  const handleRightClick = (event) => {
    event.preventDefault();
    showErrorToast("Right-click is disabled on this Page!");
  };

  useEffect(() => {
    const fetchLocation = async () => {
      const { latitude, longitude } = await getLocation();

      if (latitude && longitude) {
        setUserLatitude(latitude)
        setUserLongitude(longitude)
      }
    }

    fetchLocation()
  }, []);


  useEffect(() => {
    console.log("latitude", userLatitude);
    console.log("longitude", userLongitude);
    

  }, [userLatitude, userLongitude])

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      {/* <ToastContainer /> */}
      <ModalWithPinInput
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        tempToken={tempToken}
        onPinSubmit={handlePinSubmit}
        setForgotPasswordClicked={() => {
          setForgotPasswordClicked(true)
          setIsModalOpen(false)
        }}
      />

      <div className="bg-gradient-to-t from-[#020617] to-[#020617] w-full pt-6 pb-12 px-[20px] md:px-[50px] lg-[px-100px] 2xl:px-[250px] h-full md:h-screen  grid-cols-1 grid md:grid-cols-[1.5fr_1fr]   gap-10">
        {/* <SliderCrousel /> */}

        <DivTag className=" w-full h-full backdrop-blur-lg order-2 md:order-1 flex flex-col gap-6 shadow-lg">
          <SliderCrousel2 />

          <div className="w-full h-full overflow-hidden rounded-3xl  relative bg-gray-900 px-1 pb-6 mx-0  ">
            {/* Scrolling News Section */}
            <div className="w-full md:h-full h-[400px] relative overflow-hidden bg-[#0A0E1E]  rounded-lg shadow-lg p-6">
              <div className="scroll-wrapper ">
                <div className="flex flex-col space-y-3 scroll-content ">
                  {newsData && newsData.length > 0 ? (
                    <>
                      {newsData.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            // backgroundColor: item?.colorCode,
                            borderLeft: `20px solid ${item?.colorCode}`,
                          }}
                          className={`relative max-w-[95%] text-white bg-gray-900 hover:shadow-lg hover:shadow-blue-600 p-2 rounded-lg px-5 pb-4 pt-6 w-full shadow-md self-start`}
                        >
                          <div
                            className="text-sm font-medium leading-snug"
                            dangerouslySetInnerHTML={{ __html: item.news }}
                          />
                          <div
                            style={{
                              backgroundColor: item?.colorCode || "#8cfc03",
                            }}
                            className="absolute right-[7px] top-[2px] px-3 text-xs rounded-full text-black  "
                          >
                            Live
                          </div>
                        </div>
                      ))}

                      {/* Duplicate list for smooth looping */}
                      {newsData.map((item, index) => (
                        <div
                          key={`dup-${index}`}
                          style={{
                            // backgroundColor: item?.colorCode,
                            borderLeft: `20px solid ${item?.colorCode}`,
                          }}
                          className={`relative max-w-[95%]  text-white bg-gray-900 p-2 hover:shadow-lg shadow-blue-600  rounded-lg px-5 py-4 pb-4 pt-6   w-full shadow-md self-start`}
                        >
                          <div
                            className="text-sm font-medium leading-snug"
                            dangerouslySetInnerHTML={{ __html: item.news }}
                          />
                          <div
                            style={{
                              backgroundColor: item?.colorCode || "#8cfc03",
                            }}
                            className="absolute right-[7px] top-[2px] px-3 text-xs rounded-full text-black  "
                          >
                            Live
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <p className="text-white text-center">No News Found</p>
                  )}
                </div>
              </div>
            </div>

            <style jsx>{`
              .scroll-wrapper {
                position: absolute;
                width: 100%;
                height: 100%;
              }

              .scroll-content {
                display: flex;
                flex-direction: column;
                animation: scroll-up 45s linear infinite;
              }

              .scroll-content:hover {
                animation-play-state: paused;
              }

              @keyframes scroll-up {
                0% {
                  transform: translateY(0);
                }
                100% {
                  transform: translateY(-50%);
                }
              }
            `}</style>
          </div>

          {/* <div className="fixed bottom-2 left-0 w-full flex justify-around">
            <p className="text-white bg-black/10 backdrop-blur-md rounded-lg px-4 py-2 font-semibold text-md flex items-center justify-center gap-2">
              <ScrollText />
              Terms & Conditions
            </p>
            <p className="text-white bg-black/10 backdrop-blur-md rounded-lg px-4 py-2 font-semibold text-md flex items-center justify-center gap-2">
              <ShieldCheck />
              Privacy Policy
            </p>
          </div> */}
        </DivTag>

        <FormTag className="relative h-full w-full flex flex-col justify-between order-1 md:order-2 border-t-[20px] border-t-blue-700  rounded-[50px] bg-white ">
          {/* <NetworkBackground /> */}

          <DivTag className="flex flex-col md:mt-0 mt-4 w-full sm:w-full  pt-5">
            <div className="w-full flex justify-center">
              <ImgTag
                className="w-[150px] h-auto "
                loading="lazy"
                src="/media/logo/idspay_horizontal_blue.png"
                alt="logo"
              />
            </div>
            <DivTag className="text-center mb-2 w-full flex items-center gap-2 justify-center">
              <p className="text-gray-800 mt-4 mb-2 text-3xl font-semibold border-l-8 border-l-blue-600 rounded-l-md pl-3">
                API User Panel
              </p>

              <style jsx>{`
                @keyframes flicker {
                  0%,
                  100% {
                    opacity: 1;
                  }
                  41.99%,
                  42%,
                  48%,
                  49% {
                    opacity: 0;
                  }
                  43.01%,
                  49.01% {
                    opacity: 1;
                  }
                }
              `}</style>
            </DivTag>

            <div className=" p-4 w-full bg-white  text-gray-800 rounded-lg ">
              <div className=" px-4 gap-2 w-full pb-3 flex flex-col items-center justify-center">
                {/* USERNAME */}
                <div className="w-full">
                  <label className="text-gray-800 font-semibold text-base">
                    User ID
                  </label>
                  <div
                    className={`flex w-full flex-row gap-1 mt-1 border-l-[16px] border-l-blue-700 bg-[#eeecec]  h-[60px] text-gray-800   rounded-[15px] items-center   px-3  transition duration-300 ease-in-out transform hover:scale-103 ${userIdFocus ? "border-2 border-blue-500" : "border-[#cbcccb]"}`}
                  >
                    <User2 />
                    <input
                      onFocus={() => {
                        setUserIdFocus(true);
                        setPasswordClicked(false);
                        setOtpAccessClicked(false);
                        setPasswordFieldFocus(false);
                      }}
                      type="text"
                      className="bg-inherit font-semibold w-full outline-none border-none placeholder:font-normal focus:outline-none pl-3  uppercase"
                      id="user_id"
                      name="user_id"
                      maxLength={8}
                      value={user_id}
                      onChange={(e) => setUserId(e.target.value.toUpperCase())}
                      placeholder="Enter APID  ...APIDXXXX"
                      required
                      autoFocus
                    />
                  </div>

                  {userIdInputError && (
                    <div className="text-[16px] text-red-700 my-3 font-bold flex items-center gap-2">
                      <AlertTriangle size={18} />
                      {userIdInputError}
                    </div>
                  )}
                </div>

                {/* LOGIN METHOD RADIO */}

                {!forgotPasswordClicked && (
                  <div className="flex w-full justify-center gap-4 items-center">
                    <button
                      type="button"
                      onClick={() => {
                        setLoginMethod("password");

                        setUserIdFocus(false);
                        setPasswordClicked(true);
                        setOtpAccessClicked(false);
                        setPasswordFieldFocus(false);
                      }}
                      className={`flex justify-center tracking-wider flex-row gap-1 mt-1 bg-gradient-to-r  h-[60px]  rounded-[15px] items-center text-base font-semibold  px-3 w-full  transition duration-300 ease-in-out transform hover:scale-103 ${loginMethod === "password" ? "from-[#0A0E1E] to-blue-600 text-gray-200 " : "  from-blue-400 to-blue-200 text-gray-800"} `}
                    >
                      {" "}
                      <KeyIcon
                        className={` ${loginMethod === "password" && !forgotPasswordClicked && "animate-bounce"}`}
                      />
                      PASSWORD
                    </button>
                    <button
                      onClick={() => {
                        setLoginMethod("otp");

                        setUserIdFocus(false);
                        setPasswordClicked(false);
                        setOtpAccessClicked(true);
                        setPasswordFieldFocus(false);
                      }}
                      type="button"
                      className={`flex justify-center tracking-wider flex-row gap-1 mt-1 bg-gradient-to-r   h-[60px]  rounded-[15px] items-center text-base font-semibold   px-3 w-full  transition duration-300 ease-in-out transform hover:scale-103  ${loginMethod === "otp" ? " from-[#0A0E1E] to-blue-600 text-gray-200 " : "  from-blue-400 to-blue-200 text-gray-800"} `}
                    >
                      <SmartphoneChargingIcon
                        className={` ${loginMethod === "otp" && "animate-bounce"}`}
                      />
                      OTP ACCESS
                    </button>
                  </div>
                )}

                {/* PASSWORD INPUT (visible only when Password selected) */}
                {loginMethod === "password" && !forgotPasswordClicked && (
                  <>
                    <div className="w-full">
                      <label className=" font-semibold mt-4 text-base">
                        Password
                      </label>
                      <div
                        className={`flex  flex-row gap-1 mt-1 border-l-[16px] border-l-blue-700 h-[60px] text-gray-800 bg-[#eeecec] ${passwordFieldFocus ? "border-2 border-blue-500" : "border-[#cbcccb]"} rounded-[15px] items-center py-2  
                    px-3 w-full  transition duration-300 ease-in-out transform hover:scale-103`}
                      >
                        <Key size={22} />
                        <input
                          onFocus={() => {
                            setUserIdFocus(false);
                            setPasswordClicked(false);
                            setOtpAccessClicked(false);
                            setPasswordFieldFocus(true);
                          }}
                          autoFocus={loginMethod === "password"}
                          className="bg-inherit font-semibold w-full outline-none border-none placeholder:font-normal focus:outline-none pl-3  uppsercase"
                          type="password"
                          id="password"
                          name="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Enter Password"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <p className="flex justify-end w-full pr-2 pb-2 gap-2 items-center">
                <button
                  type="button"
                  onClick={() => {
                    if (user_id?.length !== 8) {
                      return setUserIdnputError("Please enter 8 digit ID");
                    }
                    setForgotPasswordClicked(true);
                  }}
                  className="text-blue-600 font-bold"
                >
                  Forgot Password | Pin?
                </button>
              </p>

              <div className="flex flex-col justify-start gap-4 items-center w-full mt-1">
                {/* RIGHT SIDE (CAPTCHA) */}
                <div className="w-auto transform scale-[0.77] md:scale-[0.77] origin-center">
                  <ReCAPTCHA
                    sitekey="6LdVjzIqAAAAAGc1B3BkXGFyUZmHTUYyI1aE_FtA"
                    onChange={handleCaptchaChange}
                  />

                    {/* <Turnstile
                siteKey={"0x4AAAAAAEj0gQW84SNwlqON"}
                onSuccess={(token) => {
                    setCaptchaToken(true);
                }}
                onError={() => {
                    setCaptchaToken(false);
                }}
                onExpire={() => {
                    setCaptchaToken(false);
                }}
            /> */}
                </div>
              </div>

              {/* show Otp Modal */}

              <DivTag className="  flex flex-col items-center mt-2 md:items-center md:mb-0">
                {!forgotPasswordClicked && (
                  <button
                    className={`text-center w-full max-w-[250px] mb-2 h-[60px] flex justify-center text-white  bg-gradient-to-r from-blue-600 to-blue-950 font-semibold rounded-2xl  items-center gap-2 py-3 text-base  hover:from-blue-400 hover:to-blue-600 border-1 ${
                      isLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    id="login"
                    name="login"
                    onClick={handleLogin}
                    disabled={isLoading}
                  >
                    <div className="flex justify-center rounded-full p-3 bg-white/10">
                      {" "}
                      <LogIn size={22} />
                    </div>

                    {isLoading ? "Logging in..." : "Login"}
                  </button>
                )}

                {/* {forgotPasswordClicked && (
                  <button
                    className={`text-center w-full max-w-[250px] mb-2 h-[60px] flex justify-center text-white  bg-gradient-to-r from-blue-600 to-blue-950 font-semibold rounded-2xl  items-center gap-2 py-3 text-base  hover:from-blue-400 hover:to-blue-600 border-1 `}
                    id="otp"
                    name="otp"
                    onClick={handleOtp}
                    disabled={isLoading}
                  >
                    <div className="flex justify-center rounded-full p-3 bg-white/10">
                      {" "}
                      <SmartphoneCharging size={22} />
                    </div>

                    {isLoading ? "Sending otp..." : "Get Otp"}
                  </button>
                )} */}

                <p className="flex justify-center  w-full gap-2 items-center">
                  Don't have an account?{" "}
                  <strong className="text-blue-600">
                    {" "}
                    <Link to="/SignUpForm">Sign up</Link>
                  </strong>
                </p>
              </DivTag>
            </div>
          </DivTag>

          <div class=" bg-gradient-to-r from-[#0A0E1E] to-[#0044ff] -mb-2 w-full rounded-b-[50px] text-white py-6 px-5">
            <div class="flex justify-center items-center gap-4 text-center">
              <div class="">
                <h3 class="text-lg  md:text-xl font-semibold flex justify-center items-center gap-2">
                  {" "}
                  <div className="bg-blue-700 p-2 rounded-md">
                    {" "}
                    <Zap className="text-whiteanimate-pulse" />
                  </div>{" "}
                  1M+
                </h3>
                <p class="text-[12px] text-gray-400">Registered Businesses</p>
              </div>

              <div class="">
                <h3 class="text-lg md:text-xl  font-semibold flex justify-center items-center gap-2">
                  {" "}
                  <div className="bg-blue-700 p-2 rounded-md">
                    {" "}
                    <IndianRupee className="text-white animate-pulse" />
                  </div>
                  1B+
                </h3>{" "}
                <p class="text-[12px] text-gray-400">Monthly Payments Value</p>
              </div>

              <div class="">
                <h3 class="text-lg md:text-xl  font-semibold flex justify-center items-center gap-2">
                  {" "}
                  <div className="bg-blue-700 p-2 rounded-md">
                    {" "}
                    <Receipt className="text-white animate-pulse" />
                  </div>
                  1M+
                </h3>{" "}
                <p class="text-[12px] text-gray-400">Daily Transactions</p>
              </div>
            </div>
          </div>
        </FormTag>
      </div>

      <LoginwithOtpModal
        isModalOpen={showOtpModal}
        toggleModal={() => setShowOtpModal(false)}
        title="Enter OTP"
        message={otpMessage}
        referenceId={referenceId}
        tempToken={tempToken} //  Pass temp token
        onSuccess={() => {
          setShowOtpModal(false);
          navigate("/Dashboard");
        }}
      />

      <ForgotPasswordOtpModal
        open={showOtpModalForgotPassword}
        onClose={() => {
          setForgotPasswordClicked(false);
          setShowOtpModalForgotPassword(false);
        }}
        onSubmit={verifyOtpForgotPassword}
        message={forgotPasswordResponse?.message}
      />

      {/* show switch */}

      <PasswordPinModal
        open={showPasswordPinModal}
        onClose={() => setShowPasswordPinModal(false)}
        onSubmit={handleReset}
      />

      <ToastContainer />
    </>
  );
};

export default LoginUserPage;
